import ENV from "../env";

const createStripeAccount = async (customerDetails, stripeId, orgId) => {
  const response = await fetch(`${ENV.firebaseApiUrl}/stripe/create-account`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      details: customerDetails,
      stripeId,
      orgId,
    }),
  });

  const resData = await response.json();

  if (!response.ok) {
    throw new Error(resData?.error?.raw?.message || "Erreur inconnue lors de la création Stripe");
  }
};

export default createStripeAccount;
